import { observer } from "mobx-react-lite";
import ConsoleDemo from "../../../components/Home/Demo/ConsoleDemo";
import { AppCardProps } from "../../../components/common/AppCard/AppCard";
import RouterConstants from "../../../constants/RouterConstants";
import useSecureNavigate from "../../../hooks/useSecureNavigate";
import { useLocation } from "react-router-dom";

const ProductShotDemo = () => {
	const navigate = useSecureNavigate();
	const location = useLocation();
	const cards: AppCardProps[] = [
		{ card: "automotive", onClick: () => navigate(RouterConstants.AUTOMOTIVE.path, { state: { from: location.pathname }}) },
	];

	return <ConsoleDemo cards={cards} />;
};

export default observer(ProductShotDemo);
